type Props = {
    isMessengers: string;
    values: any;
    formFields?: any[];
    textTranslte: string;
};

export const sendData = ({ isMessengers, values, formFields, textTranslte }: Props) => {
    let isValid = true;

    let result = {};
    let errors = {};

    if (isMessengers) {
        result = Object.entries(values)
            .filter(([key, value]) => key === isMessengers)
            .reduce(
                (acc, [key, value]) => ({ ...acc, [key]: value }),
                {} as any
            );
        isValid = isValid && !!(result as any)[isMessengers];
        if (!isValid) {
            errors = { ...errors, [isMessengers]: textTranslte };
        }
    } else {
        result = Object.entries(values)
            .filter(([key, value]) =>
                formFields?.some(({ id }) => id === +key)
            )
            .reduce((acc, [key, value]) => {
                const formField = formFields?.find(
                    ({ id }) => id === +key
                );
                const innerIsValid = !(formField?.required && !value);
                isValid = isValid && innerIsValid;
                if (!innerIsValid) {
                    errors = { ...errors, [key]: textTranslte };
                }
                const innerKey = formField?.type_field ?? key;
                return { ...acc, [innerKey]: value };
            }, {});

    }

    return {
        result,
        errors,
        isValid
    }
}